import { useState } from "react";
import { Col, Container, Row } from "react-grid-system";
import { useQuery } from "react-query";
import moment from "moment";
import { Sidemenu } from "../../components/Sidemenu";
import { Button } from "../../components/Button";
import Modal from "../../components/Modal";
import { QueryLoader } from "../../components/Loader";
import { OrganizationForm } from "../../components/Organizations";
import { StyledPageHeader } from "../../styles/StyledPage";
import { StyledModal } from "../../styles/StyledModal";
import { STable } from "../../styles/AdminSearchScore";
import AddIcon from "../../assets/img/icons/add.svg";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { getOrganizations } from "../../api/superadmin/organizations";

function Admins({ admins }) {
	if (admins.length === 0) return "No admins";
	return admins.map((admin) => (
		<div key={admin.id}>
			{admin.firstName} {admin.lastName} <small>({admin.email})</small>
		</div>
	));
}

/** Root (BasedOn) creates organizations and their organization admins. */
export default function OrganizationsPage() {
	const { axiosPrivate } = useAxiosPrivate();
	const { data = [], isLoading, isError, refetch } = useQuery("superadmin-organizations", () => getOrganizations(axiosPrivate));
	// null: closed, {}: new organization, an organization: add an admin to it
	const [editing, setEditing] = useState(null);

	const close = () => setEditing(null);
	const saved = () => {
		close();
		refetch();
	};

	return (
		<Container>
			<Row style={{ marginTop: "2rem" }}>
				<Col sm={12} lg={2}>
					<Sidemenu />
				</Col>
				<Col sm={12} lg={10}>
					<StyledPageHeader>
						<h1>Organizations</h1>
						<Button icon={AddIcon} onClick={() => setEditing({})}>
							Create organization
						</Button>
					</StyledPageHeader>
					{isLoading ? (
						<QueryLoader />
					) : isError ? (
						<p>Organizations could not be loaded.</p>
					) : (
						<STable>
							<thead>
								<tr>
									<td colSpan={2}>Name</td>
									<td colSpan={3}>Organization admins</td>
									<td>Status</td>
									<td>Created</td>
									<td>Actions</td>
								</tr>
							</thead>
							<tbody>
								{data.length === 0 ? (
									<tr>
										<td colSpan={8}>No organizations yet</td>
									</tr>
								) : (
									data.map((organization) => (
										<tr key={organization.id}>
											<td colSpan={2}>{organization.name}</td>
											<td colSpan={3} style={{ overflowWrap: "anywhere" }}>
												<Admins admins={organization.admins} />
											</td>
											<td>{organization.active ? "Active" : "Inactive"}</td>
											<td style={{ whiteSpace: "nowrap" }}>{moment(organization.createdAt).format("YYYY-MM-DD")}</td>
											<td>
												<Button small bg={false} onClick={() => setEditing(organization)}>
													Add admin
												</Button>
											</td>
										</tr>
									))
								)}
							</tbody>
						</STable>
					)}
				</Col>
			</Row>
			<Modal isOpen={editing !== null} onRequestClose={close} style={StyledModal} ariaHideApp={false}>
				{editing !== null && <OrganizationForm organization={editing.id ? editing : undefined} onSaved={saved} onCancel={close} />}
			</Modal>
		</Container>
	);
}
